import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { CatalogAdjustmentType } from "../../models/CatalogAdjustmentType";
import { getAdjustmentTypes } from "../../repositories/CatalogAdjustmentTypeRepository";
import { TableAdjustmentType } from "./components/TableAdjustmentType";

export const typeUrl = "/configuration/adjustments-types";

export const useAdjustmentTypes = (onError?: (error: Error) => void) => {
	return useQuery<CatalogAdjustmentType[], Error>({
		queryKey: ["adjustmentTypes"],
		queryFn: ({ signal }) => getAdjustmentTypes({}, signal),
		onError: onError,
	});
};

export const CatalogAdjustmentTypePage = () => {
	const { typeId } = useParams();

	return (
		<>
			<HelmetDexteel title="Adjustment Types" />
			<TableAdjustmentType typeId={typeId} />
		</>
	);
};
